"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const axios_1 = __importDefault(require("axios"));
const InputValidated_1 = __importDefault(require("./formControls/InputValidated"));
const PoweredByFloatspace_1 = __importDefault(require("./PoweredByFloatspace"));
const Widget_1 = require("./Widget");
const react_2 = require("react");
var RequestType;
(function (RequestType) {
    RequestType[RequestType["Booking"] = 0] = "Booking";
    RequestType[RequestType["Quote"] = 1] = "Quote";
})(RequestType || (RequestType = {}));
function customerDetail(props) {
    const [activityTypes, setActivityTypes] = (0, react_1.useState)(null);
    const [firstName, setFirstName] = (0, react_1.useState)("");
    const [lastName, setLastName] = (0, react_1.useState)("");
    const [email, setEmail] = (0, react_1.useState)("");
    const [phoneNumber, setPhoneNumber] = (0, react_1.useState)("");
    const [activityType, setActivityType] = (0, react_1.useState)("");
    const [terms, setTerms] = (0, react_1.useState)(false);
    const brand = (0, react_2.useContext)(Widget_1.BrandContext);
    const [errorModalOpen, setErrorModalOpen] = react_1.default.useState(false);
    const [bookedModalOpen, setBookedModalOpen] = react_1.default.useState(false);
    const [requestType, setRequestType] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        getActivityTypeData();
    }, [props]);
    const getActivityTypeData = () => {
        const baseUrl = "/api/widget/activityTypes/" + props.uuid;
        axios_1.default
            .get(baseUrl)
            .then((response) => {
            console.log(response.data);
            setActivityTypes(response.data);
        })
            .catch((error) => {
            console.log(error);
        });
    };
    const validateName = (name) => {
        if (name.length == 0) {
            console.log("Name is empty");
            return false;
        }
        console.log("Name is not empty");
        return true;
    };
    const validateEmail = (email) => {
        if (email.length == 0) {
            return false;
        }
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    };
    const validatePhoneNumber = (phoneNumber) => {
        if (phoneNumber.length == 0) {
            return false;
        }
        const re = /^[0-9]{10}$/;
        return re.test(phoneNumber);
    };
    const bookNow = () => {
        submit(true);
        setRequestType(RequestType.Booking);
    };
    const quote = () => {
        submit(false);
        setRequestType(RequestType.Quote);
    };
    const submit = (bookNow) => {
        let errors = [];
        if (!validateName(firstName)) {
            errors.push("First Name is invalid");
        }
        if (!validateName(lastName)) {
            errors.push("Last Name is invalid");
        }
        if (!validateEmail(email)) {
            errors.push("Email is invalid");
        }
        if (!validatePhoneNumber(phoneNumber)) {
            errors.push("Phone Number is invalid");
        }
        if (activityType.length == 0) {
            errors.push("Event Type is not selected");
        }
        if (!terms) {
            errors.push("Terms and Conditions not accepted");
        }
        if (errors.length > 0) {
            alert("Details incomplete: \n" + errors.join("\n"));
            return;
        }
        const params = new URLSearchParams();
        params.append("brandId", props.brandId);
        params.append("selectedDate", props.selectedDate.toString());
        params.append("paxCount", props.paxCount.toString());
        params.append("duration", props.duration.toString());
        params.append("selectedTime", props.selectedTime);
        params.append("firstName", firstName);
        params.append("lastName", lastName);
        params.append("email", email);
        params.append("phoneNumber", phoneNumber);
        params.append("activityType", activityType);
        params.append("foodPackage", props.foodPackage ? props.foodPackage : "");
        params.append("beveragePackage", props.beveragePackage ? props.beveragePackage : "");
        params.append("bookNow", bookNow ? "true" : "false");
        const baseUrl = "/api/widget/bookNow/" + props.uuid;
        axios_1.default
            .post(baseUrl, params)
            .then((response) => {
            setBookedModalOpen(true);
        })
            .catch((error) => {
            console.log(error);
        });
    };
    console.log("customer Detail Bradnd", brand);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Modal, { "aria-labelledby": "modal-title", "aria-describedby": "modal-desc", open: bookedModalOpen, onClose: () => {
                return;
            }, sx: { display: "flex", justifyContent: "center", alignItems: "center" } },
            react_1.default.createElement(material_1.Paper, { variant: "outlined", sx: {
                    maxWidth: 500,
                    borderRadius: "md",
                    p: 3,
                    boxShadow: "lg",
                } },
                react_1.default.createElement(material_1.Stack, null,
                    requestType === RequestType.Booking && (react_1.default.createElement(material_1.Typography, { sx: { marginTop: 2 } }, "Your booking request has been received. Check your email for updates.")),
                    requestType === RequestType.Quote && (react_1.default.createElement(material_1.Typography, { sx: { marginTop: 2 } }, "Your quote request has been received. A quote will be emailed to you shortly."))))),
        !activityTypes && react_1.default.createElement(material_1.Typography, null, "Loading..."),
        activityTypes && (react_1.default.createElement(material_1.Grid, { container: true },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.Typography, { variant: "h4" }, "Your Details")),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 },
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                            react_1.default.createElement(InputValidated_1.default, { placeholder: "First Name", onChange: (value) => {
                                    setFirstName(value);
                                }, type: "text" })),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                            react_1.default.createElement(InputValidated_1.default, { placeholder: "Last Name", onChange: (value) => {
                                    setLastName(value);
                                }, type: "text" })))),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(material_1.Stack, null,
                        react_1.default.createElement(InputValidated_1.default, { placeholder: "Email", onChange: (value) => {
                                setEmail(value);
                            }, type: "email" }))),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(material_1.Stack, null,
                        react_1.default.createElement(InputValidated_1.default, { placeholder: "Phone Number", type: "number", onChange: (value) => {
                                setPhoneNumber(value);
                            } }))),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12, sx: { mt: 1.5 } },
                    react_1.default.createElement(material_1.Stack, null,
                        react_1.default.createElement(material_1.Typography, null, "Event Type"),
                        react_1.default.createElement(material_1.Select, { defaultValue: "", onChange: (event) => {
                                setActivityType("" + event.target.value);
                            } }, activityTypes.map((type) => (react_1.default.createElement(material_1.MenuItem, { key: type, value: type }, type)))))),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12, sx: { mt: 2 } },
                    react_1.default.createElement(material_1.FormGroup, null,
                        react_1.default.createElement(material_1.FormControlLabel, { control: react_1.default.createElement(material_1.Checkbox, { onChange: (e) => {
                                    setTerms(e.target.checked);
                                } }), label: react_1.default.createElement(material_1.Typography, { color: 'primary' },
                                "I agree to the ", brand === null || brand === void 0 ? void 0 :
                                brand.name,
                                " Terms & Conditions and Privacy Policy. * ",
                                react_1.default.createElement("a", { href: brand === null || brand === void 0 ? void 0 : brand.termsUrl, target: "_blank" }, "Read our Terms and Conditions and Privacy Policy.")) }))),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12, sx: { mt: 1 } },
                    react_1.default.createElement(PoweredByFloatspace_1.default, null)),
                react_1.default.createElement(material_1.Grid, { container: true, spacing: 2, sx: { mt: 2 } },
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12, md: 6 },
                        react_1.default.createElement(material_1.Button, { variant: "contained", onClick: () => bookNow(), fullWidth: true }, "Book Now")),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12, md: 6 },
                        react_1.default.createElement(material_1.Button, { onClick: () => quote(), variant: "outlined", fullWidth: true }, "Request Quote"))))))));
}
exports.default = customerDetail;
